import script from "./ServicePackagePrice.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ServicePackagePrice.vue?vue&type=script&lang=js"
export * from "./ServicePackagePrice.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ServicePackagePrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/service-package-card/ServicePackagePrice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb8e6956"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb8e6956', __exports__)) {
    api.reload('eb8e6956', __exports__)
  }
  
}


export default __exports__